export const ConversationListConfig = {
  itemsPerPage: 20,
  observerThreshold: 1.0,
  loadingDebounceMs: 300,
  searchDebounceMs: 500,
  maxRetries: 3
} as const

export const ConversationItemConfig = {
  avatarSize: 48,
  itemHeight: 72,
  animationDuration: '0.2s',
  hoverTransform: 'translateY(-1px)'
} as const

export const InfiniteScrollConfig = {
  ...ConversationListConfig,
  rootMargin: '50px',
  threshold: 1.0
} as const

export type ConversationListConfigType = typeof ConversationListConfig
export type ConversationItemConfigType = typeof ConversationItemConfig
export type InfiniteScrollConfigType = typeof InfiniteScrollConfig
